
/**
 * Sort items by field value of given field
 * 
 * @param {array} items - items of application
 * @param {object} options - object with options for sorting
 *  @property {number|string} sort_field_id - field id for sorting items 
 *  @property {boolean} descending - sort type (if set to true - items sort by descending else by ascending)
 * 
 */

export function sortItems(items, options) {
    
      /*-- stop filtering if arguments are empty*/
      if (!items || !items.length) {
        return [];
      }

      if (!items[0].fields.length) {
        return items;
      }

      var compareFieldId = options && options.sort_field_id || items[0].fields[0].field_id;

      /* Get field value*/
      function getFieldValue(item) {
        var result = null;
        for (var i = 0; i < item.fields.length; i++) {

          if (item.fields[i].field_id == compareFieldId) {
            result = item.fields[i].field_value;
            break;
          }

        }
        return result;

      }

      /* Sort items array*/
      items.sort(function(a, b) {
        var aVal = getFieldValue(a);
        var bVal = getFieldValue(b);

        if (aVal === null) {
          return -1;
        }
        if (bVal === null) {
          return 1;
        }

        if (/^\d+$/.test(aVal) && /^\d+$/.test(bVal)) {
          return Number(aVal) < Number(bVal) ? -1 : 1;
        }

        if (/^\d+$/.test(aVal) || /^\d+$/.test(bVal)) {
          return /^\d+$/.test(aVal) ? -1 : 1;
        }

        return aVal.toLowerCase() > bVal.toLowerCase() ? 1 : -1;
      });
      return options && options.descending ? items.reverse() : items;
  }